import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { MagnifyingGlass } from '@phosphor-icons/react'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import RequestMaintenanceForm from '../../../Maintenance/RequestMaintenanceForm/RequestMaintenanceForm'

import GuidedInspectionItem from './GuidedInspectionItem'
import HasIssueItem from './HasIssueItem'
import ImagesItem from './ImagesItem'

const getDescription = (item, location, t) =>
  `${t('internal-inspections:locationItem.condition')}: ${
    item.rating ? item.rating : item.hasIssue ? t('internal-inspections:details.ratingPoor') : '-'
  }\n${t('internal-inspections:columns.location')}: ${location.name} - ${item.name}\n${
    item.description
      ? `${t('internal-inspections:locationItem.descriptionLabel')}: ${item.description}\n`
      : ''
  }${item.notes ? `${t('internal-inspections:locationItem.notes')}: ${item.notes}\n` : ''}${
    item.questions.length
      ? `${t('internal-inspections:locationItem.questions')}: ${item.questions
          .map(
            (question) =>
              `${question.question} - ${
                question.answer
                  ? t('internal-inspections:locationItem.yes')
                  : t('internal-inspections:locationItem.no')
              }`,
          )
          .join('\n')}`
      : ''
  }`

const LocationItem = ({
  setPicturesToShow,
  isGuided,
  item,
  inspectionId,
  location,
  refetchDetails,
}) => {
  const { t } = useTranslation(['internal-inspections'])
  const [workOrderModalVisible, setWorkOrderModalVisible] = React.useState(false)

  return (
    <React.Fragment>
      <div className="location-item">
        <div>
          <span className="title">{item.name}</span>
        </div>
        {item.isCheckedByUser ? (
          <React.Fragment>
            {isGuided ? (
              <GuidedInspectionItem item={item} />
            ) : (
              <HasIssueItem hasIssue={item.hasIssue} />
            )}
            {item.notes && (
              <div>
                <span className="details-label">
                  {t('internal-inspections:locationItem.notes')}
                </span>
                <span className="details-desc">{item.notes}</span>
              </div>
            )}
            <div className="right">
              {!item.maintenanceId && (item.hasIssue || item.rating === 'Poor') && (
                <button
                  onClick={() => setWorkOrderModalVisible(true)}
                  className="button button-secondary"
                >
                  {t('internal-inspections:locationItem.createWorkOrder')}
                </button>
              )}
              {item.images && item.images.length > 0 && (
                <ImagesItem
                  images={item.images}
                  setPicturesToShow={setPicturesToShow}
                  previewCount={2}
                />
              )}
            </div>
          </React.Fragment>
        ) : (
          <div className="not-inspected">
            <span>
              <MagnifyingGlass />
              {t('internal-inspections:locationItem.notInspectedYet')}
            </span>
          </div>
        )}
      </div>
      {workOrderModalVisible && (
        <ModalContainer
          headerTitle={t('internal-inspections:createMaintenanceRequest')}
          onClose={() => setWorkOrderModalVisible(false)}
        >
          <RequestMaintenanceForm
            toggleModal={() => setWorkOrderModalVisible(false)}
            inspectionId={parseInt(inspectionId)}
            description={getDescription(item, location, t)}
            checklistRoomItemId={item.id}
            onSuccess={refetchDetails}
          />
        </ModalContainer>
      )}
    </React.Fragment>
  )
}

LocationItem.propTypes = {
  item: PropTypes.object,
  location: PropTypes.object,
  isGuided: PropTypes.bool,
  inspectionId: PropTypes.number,
  setPicturesToShow: PropTypes.func,
  refetchDetails: PropTypes.func,
}

export default LocationItem
